/*
 * Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
 * This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
 * The receipt or possession of this program does not convey any rights to use, reproduce or disclose
 * its contents in whole or in part, without the specific written consent of Inovalon, Inc.
 * Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
 * is a violation of the copyright laws and may subject you to criminal prosecution.
 */
import React, { Component } from 'react'
import './Drawer.scss'
import { injectProperty } from '../../arc/configuration/ServiceLocator'
import { ITopNavBarApiClient } from '../../services/TopNavBarApiClient/contracts'
import { SettingsManager } from '../../configuration/SettingsManager'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IDrawerProps {
	//code related to your props goes here
}

export interface IDrawerState {
	authorizedForFacility: boolean
}

export class Drawer extends Component<IDrawerProps, IDrawerState> {
	@injectProperty('ITopNavBarApiClient')
	public topNavBarApiClient!: ITopNavBarApiClient

	constructor(props: Readonly<IDrawerProps>) {
		super(props)

		this.state = {
			authorizedForFacility: false,
		}
	}

	componentDidMount(): void {
		this.topNavBarApiClient.getAuthorizationStatus(SettingsManager.PRODUCT_PERMISSION_FOR_FACILITY_CONFIGURATION).then(response => {
			if (response === true) {
				this.setState({
					authorizedForFacility: true,
				})
			}
		})
	}

	render(): React.ReactNode {
		return (
			<div>
				<table>
					<tr>
						<td className="drawer-panel">
							<a href="/coveragediscovery/coveragediscoveryrequest/" target="_parent">
								<i className="request"></i>
								<span className="drawer-panel">Request</span>
							</a>
						</td>
						<td className="drawer-panel">
							<a href="/coveragediscovery/requesthistory/" target="_parent">
								<i className="document"></i>
								<span className="drawer-panel">History</span>
							</a>
						</td>
						<td className="drawer-panel">
							<a href="/coveragediscovery/batches/" target="_parent">
								<i className="batches"></i>
								<span className="drawer-panel">Batches</span>
							</a>
						</td>
						{this.state.authorizedForFacility ? (
							<td className="drawer-panel">
								<a href="/coveragediscovery/facilities/" target="_parent">
									<i className="gear"></i>
									<span className="drawer-panel">Facilities</span>
								</a>
							</td>
						) : null}
					</tr>
				</table>
			</div>
		)
	}
}
